export function useDocReferrer() {
  return typeof document !== 'undefined' ? document.referrer : '';
}
